import { useState } from 'react';
import { useNavigate } from 'react-router';
// import { useLocation } from 'react-router';
import { Button, Chip, Collapse, Stack, Typography } from '@mui/material';
import { Box, Grid } from '@mui/system';
import useNumberFormat from 'hooks/useNumberFormat';
import IconifyIcon from 'components/base/IconifyIcon';
import StatusAvatar from 'components/base/StatusAvatar';

const Ownership = ({ name, email, state, backto }) => {
  const { currencyFormat } = useNumberFormat();
  const navigate = useNavigate();
  // const location = useLocation();
  const [open, setOpen] = useState(false);
  const getStatusBadgeColor = (val) => {
    switch (val) {
      case 'Dispatched':
        return 'success';
      case 'Full':
        return 'success';
      case 'Hold':
        return 'error';
      case 'InProgress':
        return 'info';
      case 'Partial':
        return 'info';
      case 'no':
        return 'error';
      case true:
        return 'success';
      case false:
        return 'error';
      default:
        return 'info';
    }
  };

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'start', pr: 3 }}>
        <Button
          shape="circle"
          variant="soft"
          color="neutral"
          onClick={() => navigate(backto, { state: state })}
        >
          <IconifyIcon icon="material-symbols:arrow-back-rounded" fontSize={20} />
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            flex: 1,
          }}
        >
          <Stack spacing={1.5} sx={{ minWidth: 200, alignItems: 'center', flex: 1 }}>
            <StatusAvatar
              alt={name?.toUpperCase()}
              status="online"
              src={name}
              sx={{
                xs: { width: 10, height: 10, bgcolor: '#977efdff' },
                sm: { width: 50, height: 50, bgcolor: '#977efdff' },
              }}
            />

            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    xs: '14px', // mobile
                    sm: '18px', // tablets
                    md: '20px', // small desktop
                    lg: '22px', // large screen
                  },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                {`${name} - ${state.appliedCapacity} KW   `}
                <Box
                  onClick={() => setOpen(!open)}
                  sx={{
                    fontSize: { xs: '12px', sm: '15ps' },
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    color: 'blue',
                    textDecoration: 'underline',
                  }}
                >
                  {open ? 'Less' : 'More'} info
                  <IconifyIcon
                    icon={open ? 'mdi:chevron-up' : 'mdi:chevron-down'}
                    style={{ marginLeft: 4 }}
                  />
                </Box>
              </Typography>
              <Typography variant="body2" color="primary" sx={{ fontWeight: 500 }}>
                {email}
              </Typography>
            </Box>
          </Stack>
          {/* {location?.pathname == '/documents' ? null : (
            <Box sx={{ mb: 2 }}>
              <Button
                variant="soft"
                shape="square"
                color="neutral"
                sx={{ gap: 0.5, p: 1, border: '1px solid black' }}
                // , background: '#dcdae3ff'
              >
                <IconifyIcon icon="material-symbols:pending-actions-rounded" />
                <Box
                  component="span"
                  sx={{ display: { xs: 'none', sm: 'block' } }}
                  onClick={() => {
                    navigate('/documents', {
                      state: {
                        state: state, // ✅ keep your existing state
                        from: location.pathname, // ✅ store previous URL properly
                      },
                    });
                  }}
                >
                  View Documents
                </Box>
              </Button>
            </Box>
          )} */}
        </Box>

        <Collapse in={!open} timeout={250} unmountOnExit>
          <Box
            sx={{
              animation: 'fadeSlide 0.35s ease-in-out',
            }}
          >
            <Grid container spacing={{ xs: 0, sm: 6 }} xs={12} sx={{ flex: 1, mt: 2 }}>
              <Grid container spacing={0} item xs={12} sm={6} lg={3}>
                {[
                  {
                    label: 'Amount/Receive',
                    value: `${currencyFormat(state.amount, { minimumFractionDigits: 0 })}/${currencyFormat(state.totalReceivedAmount, { minimumFractionDigits: 0 })}`,
                  },
                ].map((item, i) => (
                  <Grid item xs={12} key={i}>
                    <Grid container spacin1g={4}>
                      <Grid item xs={6} sm={10} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={0} item xs={12} sm={6} lg={3}>
                {[
                  {
                    label: 'Dispatch Status',
                    value: (
                      <Chip
                        label={state.dispatchStatus || '-'}
                        variant="soft"
                        color={getStatusBadgeColor(state.dispatchStatus)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item xs={12} key={i}>
                    <Grid container spacing={0.5}>
                      <Grid item xs={6} sm={8} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={0} item xs={12} sm={6} lg={3}>
                {[
                  {
                    label: 'Doc Approved By GEDA?',
                    value: (
                      <Chip
                        label={state?.gedamanagements?.fileApprove ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.gedamanagements?.fileApprove)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item xs={12} key={i}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={10} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={0} item xs={12} sm={6} lg={3}>
                {[
                  {
                    label: 'Is Subsidy Received?',
                    value: (
                      <Chip
                        label={state?.othermanagements?.subsidyReceived ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.othermanagements?.subsidyReceived)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item xs={12} key={i}>
                    <Grid container spacing={0.5}>
                      <Grid item xs={6} sm={10} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Collapse>
        <Collapse in={open} timeout={450} unmountOnExit>
          <Box
            sx={{
              mt: 2,
              animation: 'fadeSlide 0.35s ease-in-out',
            }}
          >
            {/* {children} <-- Whatever you pass will expand here */}
            <Grid container spacing={6} xs={12} sx={{ flex: 1, mt: 2 }}>
              <Grid container spacing={0} size={{ xs: 12, sm: 6, lg: 4 }}>
                {[
                  {
                    label: 'Amount/Receive',
                    value: `${currencyFormat(state.amount, { minimumFractionDigits: 0 })}/${currencyFormat(state.totalReceivedAmount, { minimumFractionDigits: 0 })}`,
                  },
                  { label: 'City', value: state.city.name },

                  {
                    label: 'Dispatch Status',
                    value: (
                      <Chip
                        label={state.dispatchStatus || '-'}
                        variant="soft"
                        color={getStatusBadgeColor(state.dispatchStatus)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Dispatch Type',
                    value: (
                      <Chip
                        label={state.dispatchType || '-'}
                        variant="soft"
                        color={getStatusBadgeColor(state.dispatchType)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item size={{ xs: 12 }} key={i}>
                    <Grid container spacin1g={0.5}>
                      <Grid item xs={6} sm={6} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Grid container spacing={0} size={{ xs: 12, sm: 6, lg: 4 }}>
                {[
                  {
                    label: 'Doc Uploaded In GEDA?',
                    value: (
                      <Chip
                        label={state?.gedamanagements?.fileUpload ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.gedamanagements?.fileUpload)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Doc Approved By GEDA?',
                    value: (
                      <Chip
                        label={state?.gedamanagements?.fileApprove ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.gedamanagements?.fileApprove)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Feasibility report received?',
                    value: (
                      <Chip
                        label={state?.gedamanagements?.feasibilityReportStatus || 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(
                          state?.gedamanagements?.feasibilityReportStatus || false,
                        )}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Meter Charges paid?',
                    value: (
                      <Chip
                        label={state?.gedamanagements?.meterCharges || 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.gedamanagements?.meterCharges || false)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item size={{ xs: 12 }} key={i}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={10} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={0} size={{ xs: 12, sm: 6, lg: 4 }}>
                {[
                  {
                    label: 'Is Meter File Prepared?',
                    value: (
                      <Chip
                        label={state?.installationmanagements?.meterFile ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.installationmanagements?.meterFile)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Is meter Installed At Site',
                    value: (
                      <Chip
                        label={state?.installationmanagements?.meterInstalled ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.installationmanagements?.meterInstalled)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  {
                    label: 'Is File Hand Over?',
                    value: (
                      <Chip
                        label={state?.othermanagements?.fileHandover ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.othermanagements?.fileHandover)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                  // {
                  //   label: 'Is Subsidy Filed?',
                  //   value: (
                  //     <Chip
                  //       label={state?.othermanagements?.subsidyFiled ? 'Yes' : 'No'}
                  //       variant="soft"
                  //       color={getStatusBadgeColor(state?.othermanagements?.subsidyFiled)}
                  //       sx={{ textTransform: 'capitalize' }}
                  //     />
                  //   ),
                  // },
                  {
                    label: 'Is Subsidy Received?',
                    value: (
                      <Chip
                        label={state?.othermanagements?.subsidyReceived ? 'Yes' : 'No'}
                        variant="soft"
                        color={getStatusBadgeColor(state?.othermanagements?.subsidyReceived)}
                        sx={{ textTransform: 'capitalize' }}
                      />
                    ),
                  },
                ].map((item, i) => (
                  <Grid item size={{ xs: 12 }} key={i}>
                    <Grid container spacing={0.5}>
                      <Grid item xs={6} sm={10} sx={{ flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '15px', fontWeight: 700, opacity: 0.8 }}
                        >
                          {item.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '15px',
                            fontWeight: 400,
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Collapse>

        {/* Slide Animation Keyframes */}
        <style>
          {`
          @keyframes fadeSlide {
            from { opacity:0; transform: translateY(-6px); }
            to { opacity:1; transform: translateY(0); }
          }
        `}
        </style>
      </Box>
    </Box>
  );
};

export default Ownership;
